import { Button, Grid2, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Layout from 'components/Layout';
import { usePrice } from 'core/contexts/price';
import { useStyles } from './styles';
import { Title, SearchBox, CircularIndeterminate, BasicTable, PaginationControlled } from '@utriper/core-ui';

const PricesPage = () => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const { getPriceGroupTabs, prices, loading, total } = usePrice();

    const classes = useStyles();
    const history = useHistory();

    const [page, setPage] = useState(1);
    const [nameSearch, setNameSearch] = useState('');
    const MAX_PAGE = 20;

    useEffect(() => {
        getPriceGroupTabs({
            nameSearch,
            pager: {
                page,
                pageSize: MAX_PAGE,
            },
        });
    }, []);

    useEffect(() => {
        getPriceGroupTabs({
            nameSearch,
            pager: {
                page,
                pageSize: MAX_PAGE,
            },
        });
    }, [page, nameSearch]);

    const columns = [
        { align: 'left', val: 'id', label: 'Id' },
        { val: 'name', label: 'Name' },
        { val: 'experiencerId', label: 'Experiencer Id' },
        { val: 'createdOn', label: 'Created On' },
        { val: 'createdBy', label: 'Created By' },
        { val: 'updatedOn', label: 'Updated On' },
        { val: 'updatedBy', label: 'Updated By' },
        { align: 'center', val: 'status', label: 'Status' },
    ];

    const mobileColumns = [
        { align: 'left', val: 'id', label: 'Id' },
        { val: 'name', label: 'Name' },
        { align: 'center', val: 'status', label: 'Status' },
    ];

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const onChangeNameSearch = (event) => {
        setNameSearch(event.target.value);
    };

    const onClick = (event, id) => {
        history.push(`/price/${id}`);
    };

    return (
        <Layout contentClassName={classes.content}>
            <Title value={'Prices'} />
            <div style={{ marginBottom: '25px' }}>
                <Grid2 container direction="row" justifyContent="space-between" alignItems="center">
                    <SearchBox onChange={onChangeNameSearch} value={nameSearch} label={'Name'} style={{ width: '14rem', marginRight: '1rem' }} />

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                            history.push(`/price/0`);
                        }}>
                        ADD
                    </Button>
                </Grid2>
            </div>

            <div>
                {loading ? (
                    <CircularIndeterminate />
                ) : (
                    <>
                        <BasicTable columns={!isSmall ? columns : mobileColumns} values={prices} onClick={onClick} />
                        <br />
                        <Grid2 container alignItems="flex-end">
                            <Grid2 size={{ xs: 1, sm: 7 }}></Grid2>
                            <Grid2 itesize={{ xs: 11, sm: 5 }}>{total / MAX_PAGE < 1 ? null : <PaginationControlled count={Math.ceil(total / MAX_PAGE)} page={page} onChange={handlePageChange} totalItems={total} itemsPerPage={MAX_PAGE} />}</Grid2>
                        </Grid2>
                    </>
                )}
            </div>
        </Layout>
    );
};

PricesPage.displayName = 'PricesPage';

export default PricesPage;
